export { getWishlistServerAction } from 'next-flight-server-reference-proxy-loader?id=00290089feb48501f4643192b7897a7cf98cd47f79&name=getWishlistServerAction!'